import { render, staticRenderFns } from "./schedulefood.vue?vue&type=template&id=2c449847&scoped=true&"
import script from "./schedulefood.vue?vue&type=script&lang=js&"
export * from "./schedulefood.vue?vue&type=script&lang=js&"
import style0 from "./schedulefood.vue?vue&type=style&index=0&id=2c449847&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c449847",
  null
  
)

export default component.exports